import ApiService from "service/Api";
import { CatalogDescriptionPayloadTypes } from "utilities/types/CatalogDescription";
import { CatalogEthPayloadTypes } from "utilities/types/CatalogEth";

const CatalogEthService = {
  getAllCatalogsEth: async (
    page: number,
    search: string,
    limit: number,
    filterTenant: number
  ) => {
    const requestData = {
      method: "get",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      params: {
        is_voucher: 0,
        is_eth: 1,
        search: search,
        page: page,
        per_page: limit,
        filter_tenant: filterTenant,
        portal: "admin",
      },
      url: "admin/catalogs",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  storeCatalogEth: async (payload: CatalogEthPayloadTypes) => {
    const { catalogName, catalogImage, catalogProduct, tenantId } = payload;

    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        catalog_name: catalogName,
        points_needed: 0,
        image: catalogImage,
        expiry_date: "2022-12-12",
        catalog_type: "auto",
        is_voucher: 0,
        is_eth: 1,
        catalog_product: catalogProduct,
        point_type_used: "1",
        tenant_id: tenantId,
      },
      url: "admin/catalogs",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  updateCatalogEth: async (
    catalogId: string,
    payload: CatalogEthPayloadTypes
  ) => {
    const { catalogName, catalogImage, catalogProduct, tenantId } = payload;

    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        catalog_name: catalogName,
        points_needed: 0,
        image: catalogImage,
        expiry_date: "2022-12-12",
        catalog_type: "auto",
        is_voucher: 0,
        is_eth: 1,
        catalog_product: catalogProduct,
        point_type_used: "1",
        tenant_id: tenantId,
        _method: "PUT",
      },
      url: "admin/catalogs/" + catalogId,
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  deleteCatalogEth: async (catalogId: string) => {
    const requestData = {
      method: "delete",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      url: "admin/catalogs/" + catalogId,
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  updateCatalogEthDescription: async (
    payload: CatalogDescriptionPayloadTypes
  ) => {
    const {
      catalogId,
      title,
      termsAndCondition,
      purcaseAndUse,
      titleEn,
      termsAndConditionEn,
      purcaseAndUseEn,
    } = payload;

    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        catalog_id: catalogId,
        title: title,
        terms_and_condition: termsAndCondition,
        purcase_and_use: purcaseAndUse,
        title_en: titleEn,
        terms_and_condition_en: termsAndConditionEn,
        purcase_and_use_en: purcaseAndUseEn,
        _method: "PUT",
      },
      url: "admin/catalogs-description",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },
};

export default CatalogEthService;
